import React, { Component } from "react";
import $ from "jquery";
import "./DynamicAssets.scss";
import DynamicAsset from "./DynamicAsset/DynamicAsset";
import data from "./assetData";
import parse from 'html-react-parser';

class DynamicAssets extends Component {
  constructor(props) {
    super(props);
  }
  render() {

    const assetData = data;
    const dynamicAssets = assetData.map((assetData,index) => {
      if (assetData.roles.includes(this.props.role)) {
        return (
          <DynamicAsset
          key={index}
            title={assetData.title}
            image={assetData.image}
            description={parse(assetData.description)}
            ctaText={assetData.cta_text}
            ctaURL={assetData.url}
          />
        );
      }
    });
    return <div className="dynamic-asset-holder">{dynamicAssets}</div>;
  }
}

export default DynamicAssets;
